import { About } from "./about";
import { Contact } from "./contact";
import { DirectorMessage } from "./DirectorMessage";
import { Features } from "./features";
import RegistrationForm from "./Form";
import { Gallery } from "./gallery";
import { Header } from "./header";

const Home = (landingPageData) => {
    console.log(landingPageData)
  return (
    <>
      <Header data={landingPageData?.data.Header} />
      <Features data={landingPageData?.data.Features} />
      <About data={landingPageData?.data.About} />
      <DirectorMessage data={landingPageData?.data.DirectorMessage} />

      {/* <Services data={landingPageData.Services} /> */}
      <Gallery />
      <RegistrationForm />
      <Contact data={landingPageData?.data.Contact}/>
    </>
  );
};

export default Home;
